import {
  EliteTestimonialsCarousel,
  type EliteTestimonialItem,
  type EliteTestimonialsTitle
} from '../../../components/elite/EliteTestimonialsCarousel'
import { useAppMetaContent } from '../../../state-management/providers/AppMetaContentProvider'

const DEFAULT_TESTIMONIALS: EliteTestimonialItem[] = [
  {
    id: 'ramesh-k',
    quote:
      '<b>Power Rebalancing</b> is a very powerful feature and the output was very precise and accurate. Thank you and congratulations 👏 ',
    name: 'Ramesh K'
  },
  {
    id: 'nitin-j',
    quote: 'PowerUp app is intuitive and so intelligent, and the <b>Elite plan is on a whole new level.</b>',
    name: 'Nitin J'
  },
  {
    id: 'vasan-k',
    quote: '<b>Power Rebalancing</b> is a powerful and very useful tool which will definitely help the members.',
    name: 'Vasan K'
  },
  {
    id: 'raghu-r',
    quote:
      'The platform app is user-friendly with great features in it. The <b>Power Rank</b> features are excellent in identifying Equity Mutual Funds.',
    name: 'Raghu R'
  },
  {
    id: 'p-bala',
    quote:
      'I am impressed with the app that you have created and there is no doubt it will definitely go a long way in <b>making life easier for investors like me</b>',
    name: 'P Bala'
  }
]

type NewEliteLandingTestimonialsCarouselProps = {
  title?: EliteTestimonialsTitle | string
  testimonials?: EliteTestimonialItem[]
  className?: string
}

export default function NewEliteLandingTestimonialsCarousel({
  title,
  testimonials = DEFAULT_TESTIMONIALS,
  className
}: NewEliteLandingTestimonialsCarouselProps) {
  const { getEliteMembersDisplay } = useAppMetaContent()
  const resolvedTitle = resolveTestimonialsTitle(
    title ?? {
      line1: `Here's what our ${getEliteMembersDisplay('shortUpper') ?? ''} Elite`,
      line2: 'members are saying'
    }
  )

  return (
    <EliteTestimonialsCarousel
      title={resolvedTitle}
      testimonials={testimonials}
      className={className}
    />
  )
}

/** Split a single-line testimonials heading into the carousel's two-line title. */
export function resolveTestimonialsTitle(
  title: EliteTestimonialsTitle | string
): EliteTestimonialsTitle {
  if (typeof title !== 'string') return title

  const membersMatch = title.match(/^(.*\bmembers)\s+(are saying)$/i)
  if (membersMatch) {
    return {
      line1: membersMatch[1] ?? title,
      line2: membersMatch[2] ?? ''
    }
  }

  const usersMatch = title.match(/^(.*\busers)\s+(are saying)$/i)
  if (usersMatch) {
    return {
      line1: usersMatch[1] ?? title,
      line2: usersMatch[2] ?? ''
    }
  }

  return { line1: title }
}
